
const addP = (str) => str.replace(/\(|\)/g,'').replace(/([a-z]+)|([A-Z]+)|([0-9]+)/g, '($&)')

class Parantheses {
	el = null
	binding = null

	constructor() {
		this._onInput = this._onInput.bind(this)
		this._onKeydown = this._onKeydown.bind(this)
		this.isDeleting = false
	}

	created(el, binding, vnode) {
		const input = el.querySelector('input')
	}

	_onKeydown(evt) {
		if (evt.key === 'Backspace' || evt.key === 'Delete') {
			this.isDeleting = true
		}
	}

	_onInput(evt) {
		const input = evt.target
		let newValue = addP(input.value)

		if (!this.isDeleting) {
			if (input.value !== newValue) {
				input.removeEventListener('input', this._onInput, { capture: true })
				input.value = newValue
				input.dispatchEvent(new Event('input', { bubbles: true }))
				input.addEventListener('input', this._onInput, { capture: true })
			}
		}
		this.isDeleting = false

	}

	mounted(el, binding, vnode) {
		const input = el.querySelector('input')
		if (input) {
			let newValue = addP(input.value)
			input.addEventListener('keydown', this._onKeydown)
			input.addEventListener('input', this._onInput, { capture: true })

			if (input.value !== newValue) {
				input.dispatchEvent(new Event('input', { bubbles: true }))
			}

			el._onInputCleanup = () => {
				input.removeEventListener('keydown', this._onKeydown)
				input.removeEventListener('input', this._onInput, { capture: true })
			}
		}
	}

	unmounted(el) {
		if (el._onInputCleanup) {
			el._onInputCleanup()
			delete el._onInputCleanup
		}
	}
}

export const installParantheses = (app) => {
	const instance = new Parantheses

	app.directive('parantheses', {
		mounted: instance.mounted.bind(instance),
		unmounted: instance.unmounted.bind(instance),
	})
}
